{
  "lib_calendar": {
    "appointment-cancellation-dialog": {
      "buttons": {
        "back": "Retour",
        "cancel": "Annuler le rendez-vous",
        "close": "Fermer",
        "next": "Continuer"
      },
      "text": {
        "title": "Annulation de rendez-vous",
        "description": "Pouvez-vous nous en dire plus sur les raisons pour lesquelles vous ne pouvez plus respecter le rendez-vous ?",
        "appointment-cancelled-successfully": "Le rendez-vous a été annulé avec succès !",
        "block_customer": "Souhaitez-vous bloquer ce client ?",
        "message_to_customer": "Message au client",
        "no": "NON",
        "no_show": "Le client ne s'est pas présenté",
        "not_show_up": "Ce client s'est déjà présenté à {{ total }} dans le passé. date(s) non atteinte(s).",
        "not_show_up_first_time": "C'est la première fois que ce client ne s'est pas présenté.",
        "reason": "Votre raison",
        "reason-better-deal": "J'ai trouvé une meilleure offre",
        "reason-mistake": "J'ai changé d'avis ou réservé par erreur",
        "reason-other": "Autre raison",
        "reason-salon-asked-to-cancel": "Le salon m'a demandé si je pouvais annuler le rendez-vous",
        "reason-unforeseen-circumstance": "En raison de circonstances imprévues, je n'ai pas pu me rendre au rendez-vous",
        "yes": "OUI"
      }
    },
    "appointment-chat-box": {
      "text": {
        "chat-with": "Chat avec {{name}}",
        "customer": "client",
        "message": "Votre message",
        "salon": "salon"
      }
    },
    "appointment-confirmation-dialog": {
      "buttons": {
        "cancel": "Annuler",
        "confirm-and-book": "Confirmer et réserver",
        "confirm-and-update": "Confirmer et mettre à jour"
      },
      "text": {
        "title": "Confirmation de rendez-vous",
        "book-successfully": "Votre rendez-vous a été pris avec succès",
        "update-successfully": "Votre rendez-vous a été mis à jour avec succès"
      }
    },
    "appointment-details": {
      "text": {
        "serve-by-staff": "Servir par {{staff}}",
        "staff_selected_by_customer": "Le personnel est sélectionné par le client",
        "total": "Total"
      }
    },
    "appointment-details-card": {
      "buttons": {
        "checkin": "CHECK IN"
      },
      "text": {
        "appointment-canceled-by-salon": "Le rendez-vous a été annulé par le salon",
        "appointment-canceled-by-you": "Le rendez-vous a été annulé par vous",
        "status": "Statut"
      }
    },
    "appointment-details-dialog": {
      "buttons": {
        "back": "Retour",
        "edit": "Modifier la nomination"
      },
      "text": {
        "appointment_history": "Historique des rendez-vous",
        "edit_profile": "Modifier le profil",
        "more_about_customer": "En savoir plus sur ce client",
        "Visit history": "Historique des visites"
      }
    },
    "appointment-details-page": {
      "buttons": {
        "cancel": "Annuler le rendez-vous"
      },
      "text": {
        "creation_time": "Temps de création",
        "last_update": "Dernière mise à jour"
      }
    },
    "appointment-form": {
      "text": {
        "customer-selection": "Sélection des clients",
        "note": "Remarque",
        "rwg_appointment_hint": "Le service de rendez-vous de Google n'est pas modifiable",
        "service-selection": "Sélection des services",
        "staff-cannot-serve-any-hint": "Le personnel sélectionné ne peut servir aucun service sélectionné. Veuillez envisager de choisir un autre membre du personnel !",
        "staff-cannot-serve-all-hint": "Le personnel sélectionné ne peut pas servir tous les services sélectionnés. Certains d'entre eux seront pris en charge par un autre membre du personnel !",
        "staff_selected_by_customer": "Le personnel est sélectionné par le client",
        "staff-selection": "Sélection du personnel"
      }
    },
    "appointment-form-dialog": {
      "text": {
        "create_new_appointment": "Réserver un nouveau rendez-vous",
        "edit_appointment": "Modifier le rendez-vous"
      },
      "buttons": {
        "book": "RÉSERVEZ",
        "close": "Retour",
        "save": "Enregistrer"
      }
    },
    "appointment-history-dialog": {
      "text": {
        "appointment_history": "Dates vues actuellement",
        "empty_history": "L'historique des rendez-vous est vide",
        "last_seen": "Dernière observation"
      }
    },
    "appointment-table": {
      "buttons": {
        "view": "Ansehen"
      },
      "text": {
        "all": "Tous",
        "customer": "Client",
        "date": "Date",
        "service": "Service",
        "staff": "Personnel",
        "status": "Statut"
      }
    },
    "available-date-selection-by-month": {
      "text": {
        "not-available": "Non disponible. Veuillez sélectionner un autre mois !"
      }
    },
    "available-date-selection-by-serie": {
      "text": {
        "date_range": "Période",
        "end_time": "Heure de fin",
        "from_date": "Date de début",
        "start_time": "Heure de début",
        "to_date": "Date de fin",
        "repeated_week_day": "Répétition les jours de semaine",
        "repeated_week_day_required": "Veuillez sélectionner au moins un jour de la semaine"
      }
    },
    "available-date-selection-form": {
      "text": {
        "date_selection": "Sélection de la date",
        "repeat_settings": "Paramètres de répétition",
        "unable_to_block": "Rien n'est bloqué parce que le salon est fermé ou qu'il y a déjà d'autres rendez-vous/blocages aux jours choisis"
      }
    },
    "available-slot-selection-by-date": {
      "text": {
        "afternoon": "APRÈS-MIDI",
        "evening": "SOIRÉE",
        "morning": "MATIN",
        "not-available": "Non disponible. Veuillez sélectionner une autre date !"
      }
    },
    "available-slot-selection-by-week": {
      "text": {
        "not-available": "Non disponible. Veuillez sélectionner une autre semaine !"
      }
    },
    "available-slot-selection-form": {
      "buttons": {
        "date-view": "Vue de la date",
        "week-view": "Vue de la semaine"
      },
      "text": {
        "date-time-selection": "Sélection de la date et de l'heure",
        "date-time-selection-hint": "Veuillez sélectionner au moins un service",
        "slot_tact": "Intervalle de réservation",
        "slot_tact_example": {
          "5": "par ex. 09:00, 09:05, 09:10, 09:15, 09:20, etc.",
          "15": "par ex. 09:00, 09:15, 09:30, 09:45, 10:00, etc.",
          "30": "par ex. 09:00, 09:30, 10:00, 10:30, 11:00, etc.",
          "60": "par ex. 09:00, 10:00, 11:00, 12:00, 13:00, etc."
        }
      }
    },
    "blocker-deletion-dialog": {
      "buttons": {
        "delete": "Supprimer"
      },
      "text": {
        "title": "Suppression du bloqueur",
        "delete_confirmation": "Êtes-vous sûr de vouloir supprimer ce bloqueur ? Cette action ne peut être annulée.",
        "delete_single_blocker_in_series": "Supprimer uniquement ce bloqueur",
        "delete_series_blocker": "Supprimer tous les bloqueurs de cette série",
        "delete_successfully": "Supprimé avec succès"
      }
    },
    "blocker-details-card": {
      "text": {
        "belong_to_series_blocker": "Ce bloqueur est un élément d'une série de bloqueurs"
      }
    },
    "blocker-details-dialog": {
      "text": {
        "creation_time": "Temps de création",
        "last_update": "Dernière mise à jour"
      },
      "buttons": {
        "back": "Retour",
        "edit": "Bloqueur d'édition",
        "delete": "Supprimer le bloqueur"
      }
    },
    "blocker-form": {
      "text": {
        "all_day": "Bloquer pour toute la journée",
        "duration": "Durée de l'accord",
        "off": "OFF",
        "on": "ON",
        "reason": "Description",
        "reason_placeholder": "par ex. raison du blocage",
        "series_blocker": "Bloqueur de série",
        "staff-selection": "Sélection du personnel"
      }
    },
    "blocker-form-dialog": {
      "text": {
        "blocker_updated": "Le bloqueur est mis à jour avec succès",
        "create_new_blocker": "Créer un nouveau bloqueur",
        "edit_blocker": "Modifier le bloqueur",
        "new_blocker_created": "Le nouveau bloqueur est créé avec succès",
        "new_serie_blocker_created": "Le nouveau bloqueur de série est créé avec succès"
      },
      "buttons": {
        "close": "Retour",
        "create": "Créer",
        "save": "Enregistrer"
      }
    },
    "business-notification-dialog": {
      "buttons": {
        "close": "Retour"
      },
      "text": {
        "no_notification": "Aucune notification depuis {{ day }} jours",
        "notification": "Notifications",
        "staff": "Personnel"
      }
    },
    "date-picker": {
      "current": {
        "agenda": "Cette semaine",
        "day": "Aujourd'hui",
        "month": "Ce mois-ci",
        "week": "Cette semaine"
      }
    },
    "floating-buttons": {
      "buttons": {
        "new_appointment": "Nouvelle nomination",
        "new_blocker": "Nouveau bloqueur"
      }
    },
    "quick-update-appointment-dialog": {
      "buttons": {
        "cancel": "Annuler",
        "confirm": "Confirmer"
      },
      "text": {
        "original_appointment": "Rendez-vous initial",
        "original_blocker": "Bloqueur d'origine",
        "staff": "Personnel",
        "start_time": "Date et heure",
        "update_unavailable": "Le créneau horaire souhaité n'est pas disponible !",
        "updated_confirmation": "Confirmation de mise à jour",
        "updated_successfully": "Mise à jour réussie !"
      }
    },
    "tool_bar": {
      "buttons": {
        "more": "Plus",
        "view_appointment_history": "Dates vues actuellement",
        "view_cancelled_appointment": "Afficher les rendez-vous annulés"
      },
      "view_mode": {
        "agenda": "Vue de l'agenda",
        "day": "Vue du jour",
        "month": "Vue du mois",
        "week": "Vue de la semaine"
      }
    }
  }
}
